import { createDiagnosticEvent, type DiagnosticFields } from '@novelaide/shared-types/diagnostic'
export const logger = {
  error(tag: string, msg: string, fields?: DiagnosticFields): void {
    console.error(createDiagnosticEvent('error', tag, msg, fields))
  }
}
